import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { AlertLabelPipe, BadgePipe, CountBadgeRingPipe } from 'app/core/pipes/badge.pipe';
import { StatisticsService } from 'app/modules/statistics/statistics.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-management-todos',
  standalone: true,
  imports: [NgClass, RouterLink, FuseCardComponent, MatIconModule, MatProgressSpinnerModule, BadgePipe, AlertLabelPipe, CountBadgeRingPipe],
  templateUrl: './management-todos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagementTodosComponent implements OnInit, OnChanges {
  private Statistics = inject(StatisticsService);
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  loadingCount: number = 0;
  error: string | null = null;
  todos: any[] = [];
  totalCount = 0;

  todoList: { [key: string]: { route: string; params?: any } } = {
    COMPANY_COMPLIANCE_EXPIRED: { route: '/compliances', params: { tab: 'vendor' } },
    COMMUNITY_COMPLIANCE_EXPIRED: { route: '/compliances/expert-view' },
    UNREVIEWED_JOB_QUOTES: { route: '/procurement/rfps/active' },
    INSURANCE_EXPIRED: { route: '/insurances/list' },
    INSURANCE_EXPIRING: { route: '/insurances/list' },
    VIOLATION_NOTICES: { route: '/violations/notices' },
    CONTRACT_RENEWAL_REMINDER: { route: '/procurement/contracts' },
    PDC_DUE: { route: '/accounting/pdcs' },
  };

  @Input() fromDate: any = '';
  @Input() toDate: any = '';
  @Input() associationId: string | null = null;

  get loading(): boolean {
    return this.loadingCount > 0;
  }

  ngOnInit() {
    this.profile = this.auth.profile();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getData();
  }

  private getData(): void {
    this.todos = [];
    this.loadingCount++;
    const params: any = { fromDate: this.fromDate, toDate: this.toDate };
    if (this.associationId) params.association_id = this.associationId;
    this.Statistics.getManagementTodos(params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (resp: any) => {
          const all = Object.values(resp.record).map((todo: any) => ({
            alert: todo.alert,
            message: todo.message,
            route: this.todoList[todo.key]?.route,
            params: { ...this.todoList[todo.key]?.params, _ref: 'dashboard' },
          }));
          this.totalCount = all.length;
          this.todos = all.slice(0, 5);
          this.loadingCount--;
          this.cdr.markForCheck();
        },
        (error: any) => {
          this.error = error.message || 'An error occurred while getting the Todos data';
          this.loadingCount--;
          this.cdr.markForCheck();
        }
      );
  }
}
